import { useMemo } from 'react'
import { useSpaceIdFromPathname } from 'hooks/useSpaceInfoFromPathname'
import { getSafeOfflineMembershipStatus, useMyUserId } from 'use-towns-client'

import { useMyMembershipStatus } from './useMyMembershipStatus'

// this is a fast check to see if the membership is expired
// the membershipStatus query can take a while to be enabled b/c of need for linked wallets to be grabbed
// users w/ valid memberships won't notice anything
// users w/ expired memberships will see a slightly longer loading/shimmer screen for the space before seeing the renewal page
export function useIsMembershipExpired() {
    const { data } = useMyMembershipStatus()
    const myUserId = useMyUserId()
    const spaceId = useSpaceIdFromPathname()

    return useMemo(() => {
        // we're still waiting for the query to load
        // so we'll check the offline store directly
        if (data === undefined) {
            if (myUserId && spaceId) {
                const offlineMembershipStatus = getSafeOfflineMembershipStatus({
                    userId: myUserId,
                    spaceId: spaceId,
                })
                // only unexpired memberships are stored in the offline store
                if (offlineMembershipStatus) {
                    return {
                        isLoading: false,
                        isExpired: false,
                    }
                }
            }
            return {
                // we're still waiting for the query to load
                isLoading: true,
                // we don't know if the membership is expired or not
                // so don't assume it is
                isExpired: false,
            }
        }
        return {
            isLoading: false,
            isExpired: data?.isMember && data?.isExpired,
        }
    }, [data, myUserId, spaceId])
}
